import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import menuComponent from './menu.component';

let menuModule = angular
  .module('menu', [
    uiRouter
  ])
  .component('menu', menuComponent)
  .name;

export default menuModule;


// WEBPACK FOOTER //
// ./src/app/components/menu/menu.module.js